// Formatting helpers for rendering PMS Chatbot API responses in the UI.
// Kept separate from the components so the "how do we shape a raw API row
// into something readable" logic can be unit-tested / reused on its own.

export const humanizeKey = (key = "") =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const formatCellValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number") return value.toLocaleString();
  return String(value);
};

// Decides how a `data` array from the chatbot API should be rendered:
// - "chips"     → every row has exactly one field (e.g. a plain list of names/titles)
// - "keyValue"  → a single row with several fields (e.g. one project's stats)
// - "table"     → multiple rows with several fields
// - null        → nothing to render
export const getDataDisplayMode = (data) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  const columns = Object.keys(data[0] || {});
  if (columns.length <= 1) return "chips";
  if (data.length === 1) return "keyValue";
  return "table";
};

export const MAX_TABLE_ROWS = 25;

// e.g. "30 Jul, 10:42 AM" — client-side timestamp, no backend/DB to read one from.
export const formatMessageTimestamp = (date) => {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  const datePart = d.toLocaleDateString(undefined, { day: "2-digit", month: "short" });
  const timePart = d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  return `${datePart}, ${timePart}`;
};

// Fixed to the light-theme value of --add-more-btn-text so the chatbot's
// brand teal stays identical in light and dark mode instead of following
// the theme's (lighter) dark-mode variant.
export const CHATBOT_TEAL = "rgba(18, 183, 159, 1)";
